export default {"src":"/_next/static/media/IconArrowUpDown.55f2e8fd.svg","height":25,"width":16,"blurWidth":0,"blurHeight":0};